import { Component, computed, inject } from '@angular/core';
import { NavigationEnd, Router, ActivatedRoute } from '@angular/router';
import { filter, map, switchMap } from 'rxjs/operators';
import { AppstateService } from 'src/app/services/appstate.service';
import { AuthService } from 'src/app/services/auth.service';
import { NavigationService } from 'src/app/services/navigation.service';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'app-navigation',
  templateUrl: './navigation.component.html',
  styleUrl: './navigation.component.scss',
})
export class NavigationComponent {
  
  private authService: AuthService = inject(AuthService);
  private userService: UserService = inject(UserService);

  public showSidenav = computed(() => (this.authService.isAuthenticated() && this.userService.isAuthorized()));
  public sidenavPadding = computed(() => (this.appStateService.sidenavExpanded() ? '0px 16px' : '0px 12px'))
  public buttonContainerWidth = computed(() => (this.appStateService.sidenavExpanded() ? '293px' : '70px'))
  public menuitemContainerHeight = computed(() => (this.appStateService.sidenavExpanded() ? '400px' : '0px'))

  constructor(private router: Router,
              private activatedRoute: ActivatedRoute,
              public appStateService: AppstateService,
              public navigationService: NavigationService) {
  }

  ngOnInit() {
    // get the current navigation to set the main navigation value
    this.router.events
      .pipe(
        filter((event: any) => event instanceof NavigationEnd),
        map((event: NavigationEnd) => event.urlAfterRedirects))
      .subscribe(url => {
        this.appStateService.navigationUrl.set(url);
      });
      
    this.router.events
      .pipe(
        filter(routeEvent => routeEvent instanceof NavigationEnd),
        map(() => this.activatedRoute),
        map(activatedRoute => activatedRoute.firstChild),
        filter((firstChild): firstChild is ActivatedRoute => !!firstChild),
        switchMap(activatedRoute => activatedRoute.data),
      )
      .subscribe(data => {
        this.navigationService.setAppStateByRouting(data, this.activatedRoute);
      });
  }

  onNavigationClick(isActiv: boolean) {
    if (!this.appStateService.sidenavExpanded() && isActiv) {
      this.navigationService.toggleNavigationPanel();
    }
  }

  onToggleNavigationClick() {
    this.navigationService.toggleNavigationPanel();
  }  

}
